import { ReactComponent as BoomplayColorLight } from 'fym-shared/src/music-services/assets/images/boomplay-color-light.svg';
import { ReactComponent as BoomplayColorDark } from 'fym-shared/src/music-services/assets/images/boomplay-color-dark.svg';
import { ReactComponent as BoomplayColorLightPadding } from 'fym-shared/src/music-services/assets/images/boomplay-color-light-padding.svg';
import { ReactComponent as BoomplayColorDarkPadding } from 'fym-shared/src/music-services/assets/images/boomplay-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const boomplayImages: MusicServiceImages = {
  logoColor: {
    light: BoomplayColorLight,
    dark: BoomplayColorDark,
  },
  logoColorPadding: {
    light: BoomplayColorLightPadding,
    dark: BoomplayColorDarkPadding,
  },
};
